import {ApolloLink} from '@apollo/client';
import type {InternalOperation} from '@sail/data';
import {Headers} from '@sail/data';

import addContextHeaders from '../../shared/addContextHeaders';

import type {V1ContextInput} from '../../../schema/types';

export default function createContextHeadersLink() {
  return new ApolloLink(function contextHeadersLink(
    operation: InternalOperation,
    forward,
  ) {
    const v1Context = (operation.variables.v1Context || {}) as V1ContextInput;

    operation.setContext((prevContext) => {
      const headers = new Headers([
        ...Object.entries(prevContext?.headers ?? {}),
      ]);

      addContextHeaders(headers, v1Context);

      return {
        ...prevContext,
        headers: headers.getFetchHeaders(),
      };
    });

    return forward(operation);
  });
}
